import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Wrapper = styled.div`
  ${({ theme }) => `
    line-height: ${theme.lineHeight.mobile.h3};
    font-size: ${theme.fontSize.mobile.h3};
    text-align: left;
  `}

  ${({ theme }) => media.sm`
    line-height: ${theme.lineHeight.desktop.h3};
    font-size: ${theme.fontSize.desktop.h3};
  `};
`

export const Title = styled.div`
  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.nano};
    font-size: ${theme.fontSize.desktop.base};
    font-family: ${theme.fontFamily.secondary};
    font-weight: ${theme.fontWeight.bold};
    line-height: ${theme.lineHeight.desktop.h2};
  `}

  ${({ theme }) => media.sm` 
    font-size: ${theme.fontSize.mobile.h2}; 
  `}
`
